import { render, staticRenderFns } from "./editCertificate.vue?vue&type=template&id=6d84fe78&scoped=true&"
import script from "./editCertificate.vue?vue&type=script&lang=js&"
export * from "./editCertificate.vue?vue&type=script&lang=js&"
import style0 from "./editCertificate.vue?vue&type=style&index=0&id=6d84fe78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d84fe78",
  null
  
)

export default component.exports